// Base44 API Client
// This is a mock implementation - replace with your actual Base44 client setup

import { mockArticles } from './articlesData';

// Mock Base44 client
export const base44 = {
  entities: {
    Article: {
      async filter(query = {}, orderBy = '') {
        // Simulate API delay
        await new Promise(resolve => setTimeout(resolve, 500));
        
        let filtered = [...mockArticles];
        
        // Filter by published status
        if (query.published !== undefined) {
          filtered = filtered.filter(article => article.published === query.published);
        }
        
        // Sort by orderBy
        if (orderBy.startsWith('-')) {
          const field = orderBy.substring(1);
          filtered.sort((a, b) => {
            const aVal = a[field] || '';
            const bVal = b[field] || '';
            return bVal.localeCompare(aVal);
          });
        }
        
        return filtered;
      },
      
      async get(id) {
        await new Promise(resolve => setTimeout(resolve, 300));
        return mockArticles.find(article => article.id === id || article.slug === id);
      },
      
      async findBySlug(slug) {
        await new Promise(resolve => setTimeout(resolve, 300));
        return mockArticles.find(article => article.slug === slug);
      }
    },
    
    ContactSubmission: {
      async create(data) {
        // Simulate API delay
        await new Promise(resolve => setTimeout(resolve, 500));
        
        // In a real implementation, this would save to Base44
        console.log('Contact submission created:', data);
        
        const submission = {
          id: Date.now().toString(),
          ...data,
          synced_to_sheets: false,
          created_at: new Date().toISOString()
        };
        
        // Store in localStorage for demo purposes (in production, this would be in Base44)
        const existing = JSON.parse(localStorage.getItem('contactSubmissions') || '[]');
        existing.push(submission);
        localStorage.setItem('contactSubmissions', JSON.stringify(existing));
        
        return submission;
      },
      
      async filter(query = {}, orderBy = '') {
        // Simulate API delay
        await new Promise(resolve => setTimeout(resolve, 300));
        
        // Get from localStorage for demo purposes (in production, this would be from Base44)
        let submissions = JSON.parse(localStorage.getItem('contactSubmissions') || '[]');
        
        // Sort by orderBy
        if (orderBy.startsWith('-')) {
          const field = orderBy.substring(1);
          submissions.sort((a, b) => {
            const aVal = a[field] || '';
            const bVal = b[field] || '';
            return bVal.localeCompare(aVal);
          });
        }
        
        return submissions;
      }
    }
  }
};

// If you have a real Base44 client, uncomment and configure:
/*
import { Base44Client } from '@base44/sdk';

export const base44 = new Base44Client({
  apiKey: process.env.REACT_APP_BASE44_API_KEY,
  // Add your configuration here
});
*/

